






















































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import { Search, SortDirection } from '@/data/models/search.model';
import store, { State } from '@/store';
import { User, UserStatus, UserType } from '@/data/models/user.model';
import { clone } from 'lodash';

@Component
export default class CampagnaContattiSearch extends Vue {
	@Inject('CrudService') crudService!: CrudService<User>;

	state!: State;

	rows: User[] = [];
	advancedSearch: Search = new Search('user');
	loading: boolean = false;
	selected: Contatto[] = [];

	constructor() {
		super();
		this.state = store;
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadUtenti() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('utype', UserType.CALL_CENTER);
		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.advancedSearch.addSimpleFilter('status', UserStatus.ACTIVE);

		const datareq = this.crudService.searchEntities(
			User,
			'user',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			User,
			'user',
			this.advancedSearch
		);
		
		this.loading = true;

		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadUtenti();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadUtenti();
	}

	created() {
		this.loadUtenti();
	}

	submit() {
		const search = clone(this.advancedSearch);
		if (this.selected.length) search.addInFilter('id', this.selected.map(c => c.id));
		this.$emit('submit', search);
	}

}
